import { bucketFor } from './buckets';

const CHIP = {
  red: 'bg-red-600 text-white',
  orange: 'bg-orange-500 text-white',
  yellow: 'bg-amber-500 text-white',
  green: 'bg-emerald-600 text-white',
};

export function BucketBadge({ finding }) {
  const b = bucketFor(finding);
  return (
    <span
      className={`inline-block flex-none rounded-full px-2.5 py-0.5 text-xs font-semibold ${CHIP[b.key]}`}
      title={b.meaning}
    >
      {b.label}
    </span>
  );
}
